import { render } from "./FantanGame.vue?vue&type=template&id=0d364874&scoped=true&ts=true"
import script from "./FantanGame.vue?vue&type=script&lang=ts"
export * from "./FantanGame.vue?vue&type=script&lang=ts"

import "./FantanGame.vue?vue&type=style&index=0&id=0d364874&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d364874"]])

export default __exports__